import { useState } from 'react'
import CourseSearch from '../CourseSearch'
import MixedTeeSetup from './MixedTeeSetup'

/**
 * Course selection step shared between RoundSetupWizard and SessionSetupWizard.
 * Renders: name input, course search, mixed tee trigger, holes toggle.
 *
 * Props:
 *   selectedCourse, onSelectCourse, selectedTee, onSelectTee,
 *   numHoles, setNumHoles,
 *   matchPlayers, mixedTees, setMixedTees, courseTees,
 *   nameLabel, namePlaceholder, nameValue, onNameChange
 *     — generic name input (used for match name, round name, or session name)
 *   extraNameSection — optional JSX rendered before the name input (used by RoundSetupWizard for match name on quick_round)
 */
export default function StepCourse({
  selectedCourse, onSelectCourse, selectedTee, onSelectTee,
  numHoles, setNumHoles,
  matchPlayers, mixedTees, setMixedTees, courseTees,
  nameLabel, namePlaceholder, nameValue, onNameChange,
  extraNameSection,
}) {
  const [showMixedTeeSetup, setShowMixedTeeSetup] = useState(false)

  const altTeeCount = mixedTees
    ? Object.values(mixedTees).filter(t => t.name !== selectedTee?.name).length
    : 0

  if (showMixedTeeSetup && selectedTee && courseTees?.length > 1) {
    return (
      <MixedTeeSetup
        matchPlayers={matchPlayers}
        selectedTee={selectedTee}
        courseTees={courseTees}
        mixedTees={mixedTees || {}}
        onUpdate={setMixedTees}
        onBack={() => setShowMixedTeeSetup(false)}
      />
    )
  }

  return (
    <div>
      {extraNameSection}

      {nameLabel && (
        <div className="form-group">
          <label>{nameLabel}</label>
          <input
            type="text"
            value={nameValue}
            onChange={(e) => onNameChange(e.target.value)}
            placeholder={namePlaceholder}
          />
        </div>
      )}

      <div className="form-group">
        <label>Course</label>
        <CourseSearch
          selectedCourse={selectedCourse}
          onSelectCourse={onSelectCourse}
          selectedTee={selectedTee}
          onSelectTee={onSelectTee}
        />
      </div>

      {selectedTee && courseTees?.length > 1 && matchPlayers?.length > 0 && (
        <div className="form-group" style={{ marginTop: '0.75rem' }}>
          <button
            type="button"
            onClick={() => setShowMixedTeeSetup(true)}
            style={{
              width: '100%',
              padding: '0.625rem 1rem',
              fontSize: '0.875rem',
              fontWeight: '600',
              color: 'var(--accent-secondary, #f59e0b)',
              backgroundColor: 'var(--bg-tertiary)',
              border: '1px dashed var(--border-color)',
              borderRadius: '9999px',
              cursor: 'pointer',
            }}
          >
            {altTeeCount > 0
              ? `Mixed Tees: ${altTeeCount} player${altTeeCount > 1 ? 's' : ''} on alternate tees`
              : 'Setup Mixed Tees'}
          </button>
        </div>
      )}

      <div className="form-group" style={{ marginTop: '1rem' }}>
        <label>Holes</label>
        <div style={{ display: 'flex', gap: '0.75rem' }}>
          {[9, 18].map((n) => (
            <button
              key={n}
              type="button"
              className={numHoles === n ? 'btn-primary' : 'btn-secondary'}
              onClick={() => setNumHoles(n)}
              style={{ flex: 1 }}
            >
              {n} Holes
            </button>
          ))}
        </div>
      </div>
    </div>
  )
}
